export const WarehouseListActionsEnum = {
    UPLOAD_WAREHOUSES: 'upload-warehouses',
    VIEW_REGISTRATION_REQUESTS: 'view-registration-request'
};
